module.exports = {"id":"157665","name":"Scott Dann","rating":"76","photo":"./data/images/photos/3/157665.png","club":{"name":"Crystal Palace","logo":"./data/images/clubs/CrystalPalace.png"},"positions":["DC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ScottDann0.json
// module id = 3842
// module chunks = 0